<h3>
  {{ category?.Name }}
  <span class="sub">
    <a
      class="edit"
      routerLink="/home/editProviderCategory/{{ this.id }}"
      routerLinkActive="active"
      >Edit</a
    >
  </span>
</h3>
<div class="content">
  <h4 class="mt-0">Associated Programs:</h4>
  <div *ngIf="programs?.length !== 0; else noPrograms">
    <ul class="ul-1">
      <li *ngFor="let program of programs" class="mb-1">
        <a
          (click)="
            this.router.navigate(['/home/program/' + program.key + '/true'])
          "
          class="view-hover"
        >
          <span class="fs-md">{{
            program.Summary
          }}</span>
        </a>
        <br />
        <a
          (click)="deleteProgramFromProvider(program.key)"
          class="view-hover fs-sm">Delete</a>
      </li>
    </ul>
  </div>
  <ng-template #noPrograms>
    <span> (none) </span>
  </ng-template>
</div>
<button routerLink="/home/categories" routerLinkActive="active" class="view-hover">
  Back to Categories
</button>


